import { render, staticRenderFns } from "./PeriodicTable.vue?vue&type=template&id=409962c2&scoped=true"
import script from "./PeriodicTable.vue?vue&type=script&lang=js"
export * from "./PeriodicTable.vue?vue&type=script&lang=js"
import style0 from "./PeriodicTable.vue?vue&type=style&index=0&id=409962c2&prod&lang=css&scoped=true"
import style1 from "./PeriodicTable.vue?vue&type=style&index=1&id=409962c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409962c2",
  null
  
)

export default component.exports